import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { SeasonIcon } from "../../../ui/icons/SeasonIcon";
import { gridCellClass } from "./TireComparisonGrid";

type ProductInfoProps = {
  part: TirePartItem;
};

export const SeasonInfo: FunctionComponent<ProductInfoProps> = ({ part }) => {
  const { t } = useTranslation();

  return (
    <div className={gridCellClass}>
      <KeyValue>
        <strong>
          {t(`season.${part.partDetails.primaryPart.tireSeason}`)}
        </strong>
        <SeasonIcon season={part.partDetails.primaryPart.tireSeason} />
      </KeyValue>
    </div>
  );
};
